export const windowSize = {
	width: $( window ).width(),
};

$( function() {
} );

$( window ).on( 'resize', function() {
	windowSize.width = $( this ).width();
} );
